const formatLabel = (label) => label.replace(/[^\w\d\s\-\_]/g, "").split(/-|_| /).map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join("");
export {
  formatLabel
};
//# sourceMappingURL=format-label.js.map
